import { gql } from "@apollo/client"

export const ForgetPassword = gql`
mutation ForgetPassword($email: String) {
  forgetPassword(email: $email) {
    status
  }
}
`